export default __webpack_public_path__ + "static/media/unique.8ff4aa8d.jpg";